import type { IsEntitledMultiple } from '@experiences/interfaces';

import {
    post,
    put,
} from '../utility/Requests';

export const entitlementsUrl = '/api/license/accountant/Entitlement';

export async function isEntitledMultiple({
    entitlements,
    userId,
}: {
    url: string;
    entitlements: string[];
    userId?: string;
}) {
    const url = userId ? `${entitlementsUrl}/multiple?userId=${userId}` : `${entitlementsUrl}/multiple`;
    return post<IsEntitledMultiple>(url, { body: { EntitlementNames: entitlements } });
}

export async function consumeEntitlement(entitlement: string) {
    await put(`${entitlementsUrl}/${entitlement}`, { body: { } });
    return true;
}
